import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { DocumentVerificationEffects, documentVerificationFeature } from './store';

export function provideDocumentVerificationFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(documentVerificationFeature),
    provideEffects(DocumentVerificationEffects),
  ]);
}
